import React from "react";
import "./lessons-page.css";
import { Sidebar } from "../components/Sidebar";
import { MobilePannel } from "../components/MobilePannel";

const lessons = [
  {
    day: "Понеділок",
    lessons: [
      { name: "Хімія", emoji: "Chemistry" },
      { name: "Хімія", emoji: "Chemistry" },
      { name: "Мистецтво", emoji: "Art" },
      { name: "Мистецтво", emoji: "Art" },
      { name: "Географія", emoji: "Geography" },
      { name: "Географія", emoji: "Geography" },
      { name: "Фізична культура", emoji: "PE" },
    ],
  },
  {
    day: "Вівторок",
    lessons: [
      { name: "Українська мова", emoji: "UaLang" },
      { name: "Українська література", emoji: "UaLiterature" },
      { name: "Алгебра", emoji: "Algebra" },
      { name: "Англійська мова", emoji: "EngLang" },
      { name: "Фізична культура", emoji: "PE" },
      { name: "Фізика", emoji: "Physics" },
      {name: "Інформатика", emoji: "IT" },
    ]
  },
  {
    day: "Середа",
    lessons: [
      {name: "Англійська мова", emoji: "EngLang" },
      { name: "Громадянська освіта", emoji: "CE" },
      { name: "Зарубіжна література", emoji: "WorldLiterature" },
      { name: "Історія України", emoji: "UaHistory" },
      { name: "Біологія", emoji: "Biology" },
      { name: "Українська мова", emoji: "UaLang" },
      { name: "Українська мова", emoji: "UaLang" },
    ],
  },
];

function LessonsPage () {
    return (
        <>
        <section className="screen">
            <div className="sidebar-box"><Sidebar /></div>
                <section className="content">
                    <h1 className="lessons-page-header">розклад уроків</h1>
                    <h3 className="lessons-page-subheader">Оберіть необхідний день тижня</h3>
                    {lessons.map((dayItem, dayIndex) => (
                      <>
                        <div key={dayIndex} className={`lessons-page-box${dayIndex + 1}`}>
                            <h2 className={`lessons-page-box${dayIndex + 1}-name`} id={`lessons-page-box${dayIndex + 1}-name`}>{dayItem.day}</h2>
                            <p className={`lessons-page-box${dayIndex + 1}-text`} id={`lessons-page-box${dayIndex + 1}-text`}>Натисніть, щоб переглянути детальніше</p>

                        {dayItem.lessons.map ((lesson, lessonIndex) => (
                        <div key={lessonIndex} className={`lessons-page-box${dayIndex + 1}-sub${lessonIndex + 1}`} id={`lessons-page-box${dayIndex + 1}-sub${lessonIndex + 1}`}>
                          <img src={`/emoji/${lesson.emoji}.png`} className={`lessons-page-box${dayIndex + 1}-sub${lessonIndex + 1}-img`} />
                          <p className={`lessons-page-box${dayIndex + 1}-sub${lessonIndex + 1}-name`}>{lesson.name}</p>
                        </div>
                        ))}
                        </div>
                    </>
                    ))}
                </section>
                <div className="mobile-pannel"><MobilePannel/></div>
        </section>
        </> 
    );
}

export default LessonsPage;